// extracted by mini-css-extract-plugin
module.exports = {"searchWrap":"_3gBHD","closeWrappers":"_3xlAe"};